import React from 'react'
import TutorResultWarningsPartial from './partial'
import _ from 'underscore'

class TutorResultWarnings extends React.Component {

  render() {
    return (
      <div className="flex flex-col gap-2">
        {_.map(this.props.tutor_result.tutor_warnings, (tutor_warning) => {
          return (
            <TutorResultWarningsPartial
              key={tutor_warning.id}
              tutor_warning={tutor_warning}
            />
          )
        })}
      </div>
    )
  }
}

export default TutorResultWarnings